"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUDFValue = exports.isFieldType = exports.get_field_basic_uid = void 0;
var get_field_basic_uid = function (udf_type) { return "udf_" + udf_type.id; };
exports.get_field_basic_uid = get_field_basic_uid;
function isFieldType(obj) {
    return obj.id !== undefined;
}
exports.isFieldType = isFieldType;
function isUDFValue(obj) {
    return obj.field_type !== undefined;
}
exports.isUDFValue = isUDFValue;
